import { render, staticRenderFns } from "./SlotsCalendar.vue?vue&type=template&id=5b33cab0&scoped=true&lang=pug"
import script from "./SlotsCalendar.vue?vue&type=script&lang=js"
export * from "./SlotsCalendar.vue?vue&type=script&lang=js"
import style0 from "./SlotsCalendar.vue?vue&type=style&index=0&id=5b33cab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b33cab0",
  null
  
)

export default component.exports